type DateLike = unknown;

const toDate = (value: DateLike | null | undefined) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === "string" || typeof value === "number") {
    return new Date(value);
  }
  if (
    typeof value === "object" &&
    "format" in value &&
    typeof value.format === "function"
  ) {
    return new Date(value.format("YYYY-MM-DD HH:mm:ss"));
  }
  return null;
};

const formatDateTime = (
  value: DateLike | null | undefined,
  time = "00:00:00",
) => {
  const date = toDate(value);
  if (!date || Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day} ${time}`;
};

export const tableFilterService = {
  disabledDate(current: DateLike, startDate?: DateLike, endDate?: DateLike) {
    const currentDate = toDate(current);
    const minDate = toDate(startDate);
    const maxDate = toDate(endDate);

    if (!currentDate) return false;
    if (minDate && currentDate < minDate) return true;
    if (maxDate && currentDate > maxDate) return true;
    return false;
  },

  dateRangePickerFormatedDate(
    value: DateLike | null | undefined,
    time = "00:00:00",
  ) {
    return formatDateTime(value, time);
  },

  downloadCSV(data: unknown, filename = "download.csv") {
    const content = typeof data === "string" ? data : JSON.stringify(data ?? "");
    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  },

  downloadBinaryPdf(data: BlobPart, filename = "download.pdf") {
    const blob = new Blob([data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  },
};
